import { render, staticRenderFns } from "./HeardPcBackground.vue?vue&type=template&id=79076a80&scoped=true&"
import script from "./HeardPcBackground.vue?vue&type=script&lang=js&"
export * from "./HeardPcBackground.vue?vue&type=script&lang=js&"
import style0 from "./HeardPcBackground.vue?vue&type=style&index=0&id=79076a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79076a80",
  null
  
)

export default component.exports